// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__39i4A","left":"InfoRow_left__3BGKl"};